export type PortType = "Air" | "Sea" | "Road";

export const typeToApiMap: Record<PortType, "A" | "R" | "W"> = {
  Air: "A",
  Road: "R",
  Sea: "W",
};

export const apiToTypeMap: Record<"A" | "R" | "W", PortType> = {
  A: "Air",
  R: "Road",
  W: "Sea",
};

export const mapTypeToApi = (type: PortType) => typeToApiMap[type];
export const mapTypeFromApi = (type: "A" | "R" | "W") => apiToTypeMap[type];